export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/worker_job_title/current',
      method: 'GET'
    },
    {
      path: '/basis/job_title/promotion',
      method: 'GET'
    }]
  },
  getMy: {
    funKey: 'getMy',
    name: '查看我的',
    apis: [{
      path: '/basis/worker_job_title/current/my',
      method: 'GET'
    },
    {
      path: '/basis/job_title/promotion/my',
      method: 'GET'
    }]
  },
  getMyOrg: {
    funKey: 'getMyOrg',
    name: '查看本机构下的',
    apis: [{
      path: '/basis/worker_job_title/current/my_org',
      method: 'GET'
    },
    {
      path: '/basis/job_title/promotion/my_org',
      method: 'GET'
    }]
  },
  getMyOrgContainChild: {
    funKey: 'getMyOrgContainChild',
    name: '查看本机构及其子机构下的',
    apis: [{
      path: '/basis/worker_job_title/current/my_org_contain_child',
      method: 'GET'
    },
    {
      path: '/basis/job_title/promotion/my_org_contain_child',
      method: 'GET'
    }]
  },
  detail: {
    funKey: 'detail',
    name: '明细'
  }
}